import { Paper, Typography, List, ListItem, ListItemIcon, ListItemText, Grid } from '@mui/material';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import Filter from '../Filters';

interface Club {
    icon: JSX.Element;
    title: string;
    description: string;
    lat: any;
    lng: any;
    address1: any;
    regionName: string;
    regionalUnitName: string;
}

interface ListOfClubsProps {
    clubs: Club[];
    handleClick: (title: string, lat: any, lng: any) => void;
    selectedPosition: { lat: any; lng: any } | null;
    t: (key: string) => string;
}

const ListOfClubs = ({ clubs, handleClick, selectedPosition, t }: ListOfClubsProps) => {
    let timer: any;
    const navigate = useNavigate();
    const [clubsState, setClubsState] = useState<Club[]>(clubs);

    setTimeout(() => {
        if (clubsState.length == 0) {
            setClubsState(clubs);
        }
    }, 0);

    const handleDoubleClick = (description: string) => {
        navigate(`manage/${description.match(/[0-9a-fA-F-]{36}/)?.[0]}/details?lat=${selectedPosition?.lat}&lng=${selectedPosition?.lng}`);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Filter
                options={clubs
                    .filter((club: any) => club.regionName !== '<Άγνωστο>' && club.regionalUnitName !== '<Άγνωστο>')
                    ?.map(({ icon, ...club }) => club)}
                optionLabel={(option: any) => `${option.regionName} - ${option.regionalUnitName}`}
                inputChangeFn={(event: any, value: any) => {
                    if (!value) {
                        setClubsState(clubs); // Reset when cleared
                        return;
                    }

                    const results = clubs.filter((item: any) =>
                        new RegExp(value, 'i').test(`${item.regionName} - ${item.regionalUnitName}`)
                    );
                    setClubsState(results);
                }}
                renderInputFn={(params: any) => <TextField {...params} label="Περιοχή Σωματείου" />}
            />{' '}
            <Paper
                sx={{
                    overflowY: 'auto',
                    height: '100%',
                    maxHeight: 600,
                    mr: 2,
                    borderRadius: 4,
                    padding: 2,
                    boxShadow: '0px 6px 16px rgba(0,0,0,0.15)'
                }}
            >
                <Typography variant="h4" gutterBottom>
                    {t('Clubs')}
                </Typography>
                {clubsState.length > 0 ? (
                    <List>
                        {clubsState.map((item, index) => (
                            <ListItem
                                key={index}
                                component="div"
                                onClick={() => handleClick(item.title, item.lat, item.lng)}
                                onDoubleClick={() => handleDoubleClick(item.description)}
                                onTouchStart={() => {
                                    timer = setTimeout(() => {
                                        selectedPosition = { lat: item.lat, lng: item.lng };
                                        handleDoubleClick(item.description);
                                    }, 500);
                                }}
                                onTouchEnd={() => clearTimeout(timer)}
                                sx={{
                                    '&:hover': { backgroundColor: '#f0f0f0' },
                                    borderRadius: 1,
                                    cursor: 'pointer'
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 32 }}>{item.icon}</ListItemIcon>
                                <ListItemText
                                    primary={item.title}
                                    secondary={
                                        <Typography variant="body2" color="textSecondary">
                                            {item.address1}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <Typography>Loading clubs...</Typography>
                )}
            </Paper>
        </div>
    );
};

export default ListOfClubs;
